class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
 
  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);





document.addEventListener('DOMContentLoaded', function () {

  const customFields = document.getElementById('custom-size-fields');
  const measurements = document.querySelectorAll('.custom-measurement');

  if (!customFields || !measurements.length) {
    console.log('Custom size fields not found');
    return;
  }

  let customSizeActive = false;


  /* ==============================
     GET PRODUCT FORMS
  ============================== */

  function getProductForms() {
    return document.querySelectorAll(
      'form[action*="/cart/add"], product-form form'
    );
  }


  /* ==============================
     CLEAR OLD LINE ITEM PROPERTIES
  ============================== */

  function clearProperties(form) {

    form.querySelectorAll(
      '[data-custom-size-property="true"]'
    ).forEach(function (el) {
      el.remove();
    });

  }


  /* ==============================
     CHECK IF CUSTOM SIZE IS SELECTED
  ============================== */

  function isCustomSizeSelected() {

    const checkedSize = document.querySelector(
      'input[type="radio"][name="Size"]:checked'
    );

    if (!checkedSize) {
      return false;
    }

    return (
      checkedSize.value.trim().toLowerCase() === 'custom size'
    );

  }


  /* ==============================
     SHOW CUSTOM SIZE FIELDS
  ============================== */

  function showCustomFields() {

    customSizeActive = true;

    customFields.style.display = 'block';

    measurements.forEach(function (field) {
      field.required = true;
    });

    syncCustomProperties();

  }


  /* ==============================
     HIDE CUSTOM SIZE FIELDS
  ============================== */

  function hideCustomFields() {

    customSizeActive = false;

    customFields.style.display = 'none';

    measurements.forEach(function (field) {

      field.required = false;

      field.value = '';

      field.style.borderColor = '';

    });


    getProductForms().forEach(function (form) {
      clearProperties(form);
    });

  }


  /* ==============================
     CHECK CURRENT VARIANT
  ============================== */

  function checkCustomSize() {

    if (isCustomSizeSelected()) {

      showCustomFields();

    } else {

      hideCustomFields();

    }

  }


  /* ==============================
     ADD MEASUREMENTS TO CART
  ============================== */

  function syncCustomProperties() {

    getProductForms().forEach(function (form) {

      clearProperties(form);

      if (!customSizeActive) return;


      measurements.forEach(function (field) {

        const propertyName =
          field.getAttribute('data-property-name');

        const hidden =
          document.createElement('input');

        hidden.type = 'hidden';

        hidden.name =
          'properties[' + propertyName + ']';

        hidden.value = field.value;

        hidden.setAttribute(
          'data-custom-size-property',
          'true'
        );

        form.appendChild(hidden);

      });

    });

  }


  /* ==============================
     DETECT SIZE CHANGE
  ============================== */

  document.addEventListener('change', function (event) {

    if (
      event.target.matches(
        'input[type="radio"][name="Size"]'
      )
    ) {

      setTimeout(function () {
        checkCustomSize();
      }, 50);

    }

  });


  /* ==============================
     EXTRA CLICK DETECTION
     FOR YOUR THEME
  ============================== */

  document.addEventListener('click', function (event) {

    const option = event.target.closest(
      '.m-product-option--node'
    );

    if (!option) return;


    setTimeout(function () {
      checkCustomSize();
    }, 100);

  });


  /* ==============================
     UPDATE VALUES
  ============================== */

  measurements.forEach(function (field) {

    field.addEventListener('input', function () {

      field.style.borderColor = '';

      syncCustomProperties();

    });

    field.addEventListener('change', function () {

      syncCustomProperties();

    });

  });


  /* ==============================
     ADD TO CART VALIDATION
  ============================== */

  document.addEventListener(
    'submit',
    function (event) {

      const form = event.target;

      if (
        !form.matches('form[action*="/cart/add"]') &&
        !form.closest('product-form')
      ) {
        return;
      }


      if (!customSizeActive) {
        return;
      }


      let hasError = false;
      let firstEmpty = null;


      measurements.forEach(function (field) {

        if (!field.value.trim()) {

          hasError = true;

          field.style.borderColor = '#a51d1d';

          if (!firstEmpty) {
            firstEmpty = field;
          }

        } else {

          field.style.borderColor = '';

        }

      });


      if (hasError) {

        event.preventDefault();
        event.stopImmediatePropagation();

        if (firstEmpty) {

          firstEmpty.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          firstEmpty.focus();

        }

        return false;

      }


      syncCustomProperties();

    },
    true
  );


  /* ==============================
     CHECK ON PAGE LOAD
  ============================== */

  setTimeout(function () {
    checkCustomSize();
  }, 500);

});